import { baseApi } from "api/BaseApi";
import { PaginatedResponse } from "api/common/types/response.types";
import { PartialWith } from "api/common/utils/type.utils";

import { OrgDoc } from "./orgs.types";

const ORGS_V2_BASE_QUERY = "/v2/orgs";
const ORGS_BASE_QUERY = "/org";

type PaginatedOrgDoc = PaginatedResponse<OrgDoc>;

export const orgsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrgDocs: builder.query<PaginatedOrgDoc, Record<string, string>>({
      query: (filters) => ({
        url: `${ORGS_V2_BASE_QUERY}/docs/`,
        params: filters,
      }),
      providesTags: ["ORG_DOCS"],
    }),
    createOrgDoc: builder.mutation<OrgDoc, FormData>({
      query: (body) => ({
        url: `${ORGS_BASE_QUERY}/doc/`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["ORG_DOCS"],
    }),
    updateOrgDoc: builder.mutation<OrgDoc, PartialWith<OrgDoc, "snid">>({
      query: (document) => ({
        url: `${ORGS_BASE_QUERY}/doc/${document.snid}/`,
        method: "PUT",
        body: document,
      }),
      invalidatesTags: ["ORG_DOCS"],
    }),
    deleteOrgDoc: builder.mutation<OrgDoc, number>({
      query: (id) => ({
        url: `${ORGS_BASE_QUERY}/doc/${id}/`,
        method: "DELETE",
      }),
      invalidatesTags: ["ORG_DOCS"],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetOrgDocsQuery,
  useUpdateOrgDocMutation,
  useCreateOrgDocMutation,
  useDeleteOrgDocMutation,
} = orgsApi;
